<template>
  <div class="alerts-page" style="padding: 15px;">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          
          <div class="box-header with-border" style="display: flex; justify-content: space-between; align-items: center;">
            <div>
              <h3 class="box-title" style="font-size: 18px; font-weight: 600; display: inline-flex; align-items: center; gap: 8px;">
                <i class="fa fa-bell text-primary"></i> Configuración de Alertas y Notificaciones
              </h3>
              <p class="help-block" style="margin: 4px 0 0 0; font-size: 13px; color: #737373;">
                Configure reglas de notificación tipo SweetAlert que se mostrarán a los usuarios seleccionados al iniciar sesión o navegar por el sistema.
              </p>
            </div>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="openCreateModal">
              Nueva Alerta
            </el-button>
          </div>

          <div class="box-body" v-loading="loading">
            <!-- Alerts List Table -->
            <el-table :data="alerts" style="width: 100%" stripe border>
              <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>

              <el-table-column prop="title" label="Título de Alerta" min-width="170">
                <template slot-scope="scope">
                  <strong style="color: #2c3e50;">{{ scope.row.title }}</strong>
                </template>
              </el-table-column>

              <el-table-column label="Tipo de Alerta" width="230">
                <template slot-scope="scope">
                  <span :class="['alert-type-badge', scope.row.type]">
                    <i :class="getTypeIcon(scope.row.type)"></i>
                    {{ getTypeName(scope.row.type) }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column prop="message" label="Mensaje Personalizado" min-width="190">
                <template slot-scope="scope">
                  <span style="font-size: 13px; color: #606266;">{{ scope.row.message || 'Sin mensaje adicional' }}</span>
                </template>
              </el-table-column>

              <el-table-column label="Usuarios Asignados (Estado Uno a Uno)" min-width="220">
                <template slot-scope="scope">
                  <div style="max-height: 90px; overflow-y: auto;">
                    <el-tag
                      v-for="user in getFormattedTargetUsers(scope.row.target_users)"
                      :key="user.id"
                      :type="user.active ? 'success' : 'info'"
                      size="mini"
                      style="margin-right: 4px; margin-bottom: 4px;"
                    >
                      {{ user.name }}: {{ user.active ? 'Activa' : 'Inactiva' }}
                    </el-tag>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="Estado Global" width="110" align="center">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.active"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change="toggleGlobalActive(scope.row)"
                  >
                  </el-switch>
                </template>
              </el-table-column>

              <el-table-column label="Acciones" width="150" align="center">
                <template slot-scope="scope">
                  <el-tooltip content="Probar / Vista Previa" placement="top">
                    <el-button type="info" icon="el-icon-view" size="mini" circle @click="previewAlert(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip content="Editar Alerta" placement="top">
                    <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="openEditModal(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip content="Eliminar Alerta" placement="top">
                    <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteAlert(scope.row)"></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>
      </div>
    </div>

    <!-- Create / Edit Modal -->
    <el-dialog :title="isEditing ? 'Editar Alerta' : 'Nueva Alerta'" :visible.sync="dialogVisible" width="680px" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="alertForm" label-width="170px" label-position="left">
        
        <el-form-item label="Título de la Alerta" prop="title">
          <el-input v-model="form.title" placeholder="Ej: Alerta: Turnos Próxima Semana"></el-input>
        </el-form-item>

        <el-form-item label="Tipo de Alerta" prop="type">
          <el-select v-model="form.type" placeholder="Seleccione el tipo de alerta" style="width: 100%;">
            <el-option label="Sin turnos asignados para la próxima semana (Naranja)" value="unassigned_next_week"></el-option>
            <el-option label="Sin turnos asignados para la semana actual (Rojo Urgente)" value="unassigned_current_week"></el-option>
            <el-option label="Días sin asignación de turno (Azul Informativo)" value="unassigned_days"></el-option>
            <el-option label="Sin turnos asignados para el Lunes (Turno PRENOC / Nocturno)" value="unassigned_monday_prenoc"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Mensaje Personalizado" prop="message">
          <el-input
            type="textarea"
            :rows="3"
            v-model="form.message"
            placeholder="Mensaje explicativo u orientativo que verá el usuario en la alerta emergente..."
          ></el-input>
        </el-form-item>

        <el-form-item label="Asignar Usuarios">
          <el-radio-group v-model="targetMode" @change="handleTargetModeChange">
            <el-radio label="all">Todos los Usuarios</el-radio>
            <el-radio label="specific">Seleccionar Usuarios Uno a Uno</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="targetMode === 'specific'" label="Usuarios Destino">
          <el-select
            v-model="selectedUserIds"
            multiple
            filterable
            collapse-tags
            placeholder="Buscar y seleccionar usuarios uno a uno..."
            style="width: 100%; margin-bottom: 12px;"
            @change="syncTargetUsersFromSelected"
          >
            <el-option
              v-for="u in userOptions"
              :key="u.id"
              :label="u.name + ' (' + (u.email || u.profile || 'Sin Email') + ')'"
              :value="u.id"
            ></el-option>
          </el-select>

          <!-- List of selected users with individual active toggle -->
          <div style="border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px; max-height: 220px; overflow-y: auto; background: #fafafa;">
            <div v-if="form.target_users.length === 0" style="color: #909399; text-align: center; font-size: 13px; padding: 10px 0;">
              Busque y seleccione usuarios en la casilla superior para agregarlos uno a uno.
            </div>
            <div
              v-for="target in form.target_users"
              :key="target.user_id"
              style="display: flex; justify-content: space-between; align-items: center; padding: 8px 10px; background: #ffffff; border: 1px solid #ebeef5; border-radius: 4px; margin-bottom: 6px;"
            >
              <div>
                <strong style="color: #2c3e50; font-size: 13px;">{{ getUserDisplayName(target.user_id) }}</strong>
              </div>
              <div style="display: flex; align-items: center; gap: 10px;">
                <span style="font-size: 12px; color: #606266;">Alerta:</span>
                <el-switch
                  v-model="target.active"
                  active-text="Activa"
                  inactive-text="Inactiva"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                >
                </el-switch>
                <el-button type="text" style="color: #f56c6c; margin-left: 5px;" icon="el-icon-delete" @click="removeUserFromTarget(target.user_id)"></el-button>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Estado Global Regla">
          <el-switch
            v-model="form.active"
            active-text="Habilitada"
            inactive-text="Deshabilitada"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancelar</el-button>
        <el-button type="primary" :loading="saving" @click="saveAlert">Guardar Alerta</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  name: 'AlertsConfig',
  data() {
    return {
      loading: false,
      saving: false,
      alerts: [],
      userOptions: [],
      dialogVisible: false,
      isEditing: false,
      editingId: null,
      targetMode: 'all',
      selectedUserIds: [],
      form: {
        title: '',
        type: 'unassigned_next_week',
        message: '',
        target_users: [],
        active: true
      },
      rules: {
        title: [{ required: true, message: 'Ingrese el título de la alerta', trigger: 'blur' }],
        type: [{ required: true, message: 'Seleccione el tipo de alerta', trigger: 'change' }]
      }
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios.get('/api/alerts')
        .then(response => {
          this.alerts = response.data.alerts || [];
          this.userOptions = response.data.users || [];
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$message.error('Error al cargar la lista de alertas.');
        });
    },

    getTypeName(type) {
      switch (type) {
        case 'unassigned_next_week': return 'Sin turnos próxima semana';
        case 'unassigned_current_week': return 'Sin turnos semana actual';
        case 'unassigned_days': return 'Días sin asignación de turno';
        case 'unassigned_monday_prenoc': return 'Sin turnos Lunes (PRENOC)';
        default: return type;
      }
    },

    getTypeIcon(type) {
      switch (type) {
        case 'unassigned_next_week': return 'fa fa-calendar-minus-o';
        case 'unassigned_current_week': return 'fa fa-exclamation-triangle';
        case 'unassigned_days': return 'fa fa-calendar-times-o';
        case 'unassigned_monday_prenoc': return 'fa fa-moon-o';
        default: return 'fa fa-bell';
      }
    },

    getSwalIcon(type) {
      switch (type) {
        case 'unassigned_next_week': return 'warning';
        case 'unassigned_current_week': return 'error';
        case 'unassigned_days': return 'info';
        case 'unassigned_monday_prenoc': return 'warning';
        default: return 'warning';
      }
    },

    getSwalColor(type) {
      switch (type) {
        case 'unassigned_next_week': return '#e6a23c';
        case 'unassigned_current_week': return '#f56c6c';
        case 'unassigned_days': return '#409EFF';
        case 'unassigned_monday_prenoc': return '#e67e22';
        default: return '#e6a23c';
      }
    },

    getUserDisplayName(userId) {
      if (userId === 'all') return 'Todos los Usuarios';
      const found = this.userOptions.find(u => u.id === userId || u.id === parseInt(userId));
      return found ? `${found.name} (${found.email || found.profile || 'Sin Email'})` : `Usuario #${userId}`;
    },

    getFormattedTargetUsers(targetUsers) {
      if (!targetUsers || targetUsers.length === 0 || (targetUsers.length === 1 && targetUsers[0].user_id === 'all')) {
        const isAct = (targetUsers && targetUsers[0] && targetUsers[0].active !== undefined) ? targetUsers[0].active : true;
        return [{ id: 'all', name: 'Todos los Usuarios', active: isAct }];
      }
      return targetUsers.map(t => ({
        id: t.user_id,
        name: this.getUserDisplayName(t.user_id),
        active: t.active !== undefined ? t.active : true
      }));
    },

    handleTargetModeChange(val) {
      if (val === 'all') {
        this.selectedUserIds = [];
        this.form.target_users = [{ user_id: 'all', active: true }];
      } else {
        if (this.form.target_users.length === 1 && this.form.target_users[0].user_id === 'all') {
          this.form.target_users = [];
          this.selectedUserIds = [];
        }
      }
    },

    syncTargetUsersFromSelected() {
      // Retain existing active states for already selected users
      const currentMap = {};
      this.form.target_users.forEach(t => {
        if (t.user_id !== 'all') {
          currentMap[t.user_id] = t.active !== undefined ? t.active : true;
        }
      });

      this.form.target_users = this.selectedUserIds.map(uid => ({
        user_id: uid,
        active: currentMap[uid] !== undefined ? currentMap[uid] : true
      }));
    },

    removeUserFromTarget(userId) {
      this.selectedUserIds = this.selectedUserIds.filter(id => id !== userId);
      this.syncTargetUsersFromSelected();
    },

    openCreateModal() {
      this.isEditing = false;
      this.editingId = null;
      this.resetForm();
      this.dialogVisible = true;
    },

    openEditModal(row) {
      this.isEditing = true;
      this.editingId = row.id;

      const rawTargets = Array.isArray(row.target_users) ? JSON.parse(JSON.stringify(row.target_users)) : [];
      if (rawTargets.length === 0 || (rawTargets.length === 1 && rawTargets[0].user_id === 'all')) {
        this.targetMode = 'all';
        this.selectedUserIds = [];
        this.form.target_users = [{ user_id: 'all', active: true }];
      } else {
        this.targetMode = 'specific';
        this.selectedUserIds = rawTargets.map(t => t.user_id);
        this.form.target_users = rawTargets;
      }

      this.form.title = row.title;
      this.form.type = row.type;
      this.form.message = row.message || '';
      this.form.active = row.active;
      this.dialogVisible = true;
    },

    resetForm() {
      this.targetMode = 'all';
      this.selectedUserIds = [];
      this.form = {
        title: '',
        type: 'unassigned_next_week',
        message: '',
        target_users: [{ user_id: 'all', active: true }],
        active: true
      };
      if (this.$refs.alertForm) {
        this.$refs.alertForm.resetFields();
      }
    },

    saveAlert() {
      this.$refs.alertForm.validate(valid => {
        if (!valid) return;

        if (this.targetMode === 'specific' && this.form.target_users.length === 0) {
          this.$message.warning('Por favor seleccione al menos un usuario.');
          return;
        }

        this.saving = true;
        const payload = {
          title: this.form.title,
          type: this.form.type,
          message: this.form.message,
          target_users: this.targetMode === 'all' ? [{ user_id: 'all', active: true }] : this.form.target_users,
          active: this.form.active
        };

        const request = this.isEditing
          ? axios.put(`/api/alerts/${this.editingId}`, payload)
          : axios.post('/api/alerts', payload);

        request
          .then(response => {
            this.saving = false;
            this.dialogVisible = false;
            this.$message.success(response.data.message || 'Guardado correctamente.');
            this.fetchData();
          })
          .catch(error => {
            this.saving = false;
            this.$message.error('Error al guardar la alerta.');
          });
      });
    },

    toggleGlobalActive(row) {
      axios.put(`/api/alerts/${row.id}`, {
        title: row.title,
        type: row.type,
        message: row.message,
        target_users: row.target_users,
        active: row.active
      })
      .then(() => {
        this.$message.success(`Alerta "${row.title}" ${row.active ? 'activada' : 'desactivada'}.`);
      })
      .catch(() => {
        row.active = !row.active;
        this.$message.error('No se pudo actualizar el estado de la alerta.');
      });
    },

    deleteAlert(row) {
      this.$confirm(`¿Está seguro de eliminar la alerta "${row.title}"?`, 'Confirmación', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        axios.delete(`/api/alerts/${row.id}`)
          .then(res => {
            this.$message.success('Alerta eliminada.');
            this.fetchData();
          })
          .catch(() => {
            this.$message.error('Error al eliminar la alerta.');
          });
      }).catch(() => {});
    },

    previewAlert(row) {
      const swalIcon = this.getSwalIcon(row.type);
      const swalColor = this.getSwalColor(row.type);

      Swal.fire({
        icon: swalIcon,
        title: row.title,
        html: `
          <div style="text-align: left; font-size: 14px;">
            <p><strong>Mensaje:</strong> ${row.message || 'Sin mensaje adicional.'}</p>
            <p><strong>Tipo:</strong> <span style="color: ${swalColor}; font-weight: bold;">${this.getTypeName(row.type)}</span></p>
            <div style="background-color: #f8f9fa; border-left: 4px solid ${swalColor}; padding: 10px; margin-top: 10px; border-radius: 4px;">
              <small style="color: #606266;">Vista previa emergente tipo SweetAlert2. Solo mostrará trabajadores pertenecientes a las áreas asignadas al usuario.</small>
            </div>
          </div>
        `,
        confirmButtonText: 'Entendido',
        confirmButtonColor: swalColor,
      });
    }
  }
};
</script>

<style scoped>
.alerts-page {
  padding: 15px;
}
.alert-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}
.alert-type-badge.unassigned_next_week {
  background-color: #fdf6ec;
  color: #e6a23c;
  border: 1px solid #faecd8;
}
.alert-type-badge.unassigned_current_week {
  background-color: #fef0f0;
  color: #f56c6c;
  border: 1px solid #fde2e2;
}
.alert-type-badge.unassigned_days {
  background-color: #ecf5ff;
  color: #409eff;
  border: 1px solid #d9ecff;
}
</style>
